import { NotOverridableComponentProps } from '../../../../../model/Component'
import { AppBox } from '../AppBox'
import Menu, { MenuProps } from '@mui/material/Menu'
import { AppMenuList } from './AppMenuList'
import { AppPaper } from '../AppPaper'
import { handlePassedSx } from '../../../../../feature/theme/model/Sx'

export type AppMenuProps = NotOverridableComponentProps<MenuProps>

const getSafeAnchorEl = (anchorEl: MenuProps['anchorEl']) => {
  const resolvedAnchor = typeof anchorEl === 'function' ? anchorEl() : anchorEl

  if (resolvedAnchor instanceof HTMLElement) {
    return resolvedAnchor.isConnected ? resolvedAnchor : null
  }

  return resolvedAnchor ?? null
}

export function AppMenu(props: AppMenuProps) {
  const {
    anchorEl,
    open,
    PaperProps: {
      component: PaperComponent = AppPaper,
      sx: paperSx = [],
      ...restPaperProps
    } = {},
    MenuListProps: {
      component: MenuListComponent = AppMenuList,
      ...restMenuListProps
    } = {},
    ...rest
  } = props

  const safeAnchorEl = getSafeAnchorEl(anchorEl)
  const isOpen = Boolean(open) && safeAnchorEl !== null

  return (
    <AppBox
      anchorEl={safeAnchorEl}
      open={isOpen}
      PaperProps={{
        variant: 'elevation',
        ...restPaperProps,
        component: PaperComponent,
        sx: [
          styles.paper,
          ...handlePassedSx(paperSx),
        ],
      }}
      {...rest}
      MenuListProps={{
        direction: 'column',
        ...restMenuListProps,
        component: MenuListComponent,
      }}
      component={Menu}
    />
  )
}

const styles = {
  paper: {
    padding: 10,
    border: 0,
    borderRadius: '10px',
    '& .MuiMenuItem-root': {
      fontSize: 12,
    },
    '& .MuiTypography-root': {
      fontSize: 12,
    },
  },
}
